import {
  ApplySchemaAttributes,
  MarkExtension,
  MarkExtensionSpec,
  MarkSpecOverride,
  extension,
} from 'remirror';

export interface PauseMarkOptions {
  className?: string;
}

const defaultOptions: Required<PauseMarkOptions> = {
  className: 'pause-mark',
};

@extension<PauseMarkOptions>({
  defaultOptions,
  staticKeys: [],
  handlerKeys: [],
  customHandlerKeys: [],
})
export class PauseMark extends MarkExtension<PauseMarkOptions> {
  get name() {
    return 'pause' as const;
  }

  createMarkSpec(
    extra: ApplySchemaAttributes,
    override: MarkSpecOverride
  ): MarkExtensionSpec {
    return {
      ...override,
      inclusive: false,
      // prevents overwrites, pause takes precedences over all other cue marks
      excludes: 'tempo loudness pitch pause',
      attrs: {
        ...extra.defaults(),
        value: { default: '' },
      },
      parseDOM: [
        {
          tag: 'pause',
          getAttrs: (dom: Node | string) => {
            const el = dom as Element;
            return {
              ...extra.parse(dom),
              value: el.getAttribute('value') ?? '',
            };
          },
        },
        ...(override.parseDOM ?? []),
      ],
      toDOM: node => {
        const attrs: Record<string, string | number | undefined> = {
          ...extra.dom(node),
          class: this.options.className,
          value: node.attrs.value,
        };
        return ['pause', attrs, 0];
      },
    };
  }
}

export default PauseMark;
